<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div>
      <eds-section-header
        [level]="3"
        theme="basic"
        size="h3"
        [asOfLabel]="'products.as-of' | translate: brConfig.fundId"
        [asOfDate]="fundPerformanceData?.performanceDates?.asOfDate"
        [analyticsName]="heading"
        [tooltip]="tooltips['products-calendar-year-returns-section']"
        edsSpacing="sm"
        >{{ heading }}
        <eds-footnote
          placement="Calendar Year:CalendarPerformance"
        ></eds-footnote>
      </eds-section-header>
      <div *ngIf="isError">
        <div>
          <span>
            {{ "products.no-performance-data" | translate: brConfig.fundId }}
          </span>
        </div>
      </div>
      <div
        *ngIf="fundPerformanceData?.tableData.length === 0"
        aria-live="polite"
      >
        <div>
          <h6>{{ "products.no-performance-hist-data" | translate }}</h6>
          <br />
        </div>
      </div>
      <div *ngIf="!isError && fundPerformanceData?.tableData?.length">
        <div>
          <div *ngIf="periodEndToggle.length > 1">
            <eds-toggle
              [toggleButtons]="periodEndToggle"
              (toggleActive)="onPeriodEndUpdate($event)"
              [ariaControls]="'calenderData'"
            ></eds-toggle>
          </div>
        </div>
        <br />
        <ng-container *ngIf="performanceStatusCaveat">
          <eds-proximal
            edsSpacing="lg"
            edsPadding
            edsPaddingBottom="sm"
            [placement]="performanceStatusCaveat"
          ></eds-proximal>
          <br />
        </ng-container>
        <eds-proximal placement="PerformanceCalendarProximalTop"></eds-proximal>
        <div style="width: 100%">
          <ng-container
            *ngIf="
              fundPerformanceData?.graphData && !fundPerformanceConfig.hideChart
            "
          >
            <eds-proximal
              placement="PerformanceCalendarChartProximalTop"
            ></eds-proximal>
            <ft-fund-performance-column-chart
              [seriesData]="fundPerformanceData.graphData"
              [xAxisCategories]="fundPerformanceData.years"
              [isPutnamFund]="fundPerformanceConfig.isPutnamFund"
              [tickInterval]="tickInterval"
            >
            </ft-fund-performance-column-chart>
            <eds-proximal
              placement="PerformanceCalendarChartProximalBottom"
            ></eds-proximal>
          </ng-container>
          <!-- No graph data error message -->
          <ng-container *ngIf="fundPerformanceData?.graphData?.length === 0">
            <p>{{ "products.no-chart-data-found" | translate }}</p>
          </ng-container>
        </div>

        <br />
        <ft-fund-performance-calendar-year-table
          [fundPerformanceData]="fundPerformanceData?.tableData"
          [fundPerformanceDates]="fundPerformanceData?.performanceDates"
          [fundPerformanceConfig]="fundPerformanceConfig"
          [tableLabel]="fundPerformanceData?.tableLabel"
          [years]="fundPerformanceData?.years"
          [tableCols]="fundPerformanceData?.tableCols"
          [showYearToDate]="fundPerformanceData?.showYearToDate"
          [fundId]="brConfig.fundId"
          [containerId]="'calenderData'"
        >
        </ft-fund-performance-calendar-year-table>
        <div *ngIf="fundPerformanceConfig.showMifid">
          <eds-title size="h6" theme="basic" [isLight]="true">
            {{ "products.perf-inception-mifid" | translate: brConfig.fundId }}
            {{ fundPerformanceData.performanceDates.inceptionDate }}
            {{
              "products.perf-inception-mifid-end" | translate: brConfig.fundId
            }}
          </eds-title>
        </div>
      </div>
      <eds-expand-collapse
        [collapsedButton]="
          'products.view-all-class-perf' | translate: brConfig.fundId
        "
        [expandedButton]="
          'products.view-all-class-perf' | translate: brConfig.fundId
        "
        top="true"
        paddingNone="true"
        borderNone="true"
        edsSpacing="md"
        *ngIf="fundPerformanceData?.allShareClassesTableData?.tableData?.length"
      >
        <ft-fund-performance-calendar-year-table
          [fundPerformanceData]="
            fundPerformanceData?.allShareClassesTableData?.tableData
          "
          [fundPerformanceDates]="fundPerformanceData?.performanceDates"
          [fundPerformanceConfig]="fundPerformanceConfig"
          [tableLabel]="fundPerformanceData?.tableLabel"
          [years]="fundPerformanceData?.allShareClassesTableData?.years"
          [tableCols]="fundPerformanceData?.allShareClassesTableData?.tableCols"
          [showYearToDate]="
            fundPerformanceData?.allShareClassesTableData?.showYearToDate
          "
          [fundId]="brConfig.fundId"
          [isAllShareClasses]="true"
        >
        </ft-fund-performance-calendar-year-table>
      </eds-expand-collapse>
      <ng-container *ngIf="fundPerformanceData?.tableData?.length">
        <eds-proximal
          placement="PerformanceCalendarProximalBottom"
        ></eds-proximal>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Fund Performance Component - Calendar Year</h5>
</ng-template>
